import React from 'react'
import { Link } from 'react-router-dom'

export default function HealthcarePremise({ data, extraClass = "" }) {
    if (!data) return null;
    return (
        <section className={`healthcare-Premise ${extraClass}`}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-12 col-lg-6">
                        <div className="facilities-image">
                            {data?.image && (
                                <img src={data?.image} alt={data?.title} className="img-responsive" width={data?.imageWidth} height={data?.imageHeight} loading="lazy" decoding="async" />
                            )}
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-6">
                        <div className="facilities-content">
                            <div className="wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="1.2s" >
                                {data?.title && (<h3 className="heading">{data?.title}</h3>)}
                                {data?.subtitle && (<span className="gradient-color">{data?.subtitle} </span>)}
                                {data?.reasons?.length > 0 && (
                                    <ul>
                                        {data.reasons.map((item, index) => (
                                            <li  key={index}dangerouslySetInnerHTML={{ __html: item }}    />
                                        ))}
                                    </ul>
                                )}
                                {data?.buttonText && (
                                    <div className="ensures-btn">
                                        <Link to={data?.buttonLink} className="default-btn" >
                                            <span>{data?.buttonText}</span>
                                        </Link>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}



